import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "gray-rectangle",
  "use": "gray-rectangle-usage",
  "viewBox": "0 0 11 11",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11 11\" id=\"gray-rectangle\"><rect width=\"11\" height=\"11\" rx=\"2\" fill=\"#DDE1E6\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol